/**
 * Sticky bottom action bar for the builder.
 *
 * Renders Save / Cancel / Preview buttons. The Save handler is async so
 * we can show a spinner while the PATCH is in flight.
 */

import { Loader2, Save, X, RefreshCw } from 'lucide-react';
import { Button } from '../../../components/ui/button';

interface SaveBarProps {
  saving: boolean;
  previewLoading: boolean;
  onSave: () => void;
  onCancel: () => void;
  onPreview: () => void;
  /** Optional message rendered to the left of the buttons. */
  message?: string;
}

export function SaveBar({ saving, previewLoading, onSave, onCancel, onPreview, message }: SaveBarProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 border-t border-border bg-background/95 backdrop-blur z-30">
      <div className="px-4 py-2 flex items-center justify-between">
        <div className="text-xs text-muted-foreground">{message || 'Unsaved changes'}</div>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onPreview}
            disabled={previewLoading}
            className="h-8"
          >
            {previewLoading
              ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />
              : <RefreshCw className="h-3.5 w-3.5 mr-1" />}
            Preview
          </Button>
          <Button type="button" variant="outline" size="sm" onClick={onCancel} className="h-8">
            <X className="h-3.5 w-3.5 mr-1" />
            Cancel
          </Button>
          <Button type="button" size="sm" onClick={onSave} disabled={saving} className="h-8">
            {saving
              ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />
              : <Save className="h-3.5 w-3.5 mr-1" />}
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}
